export default {
  presenter: 'svoboda',
  title: 'Kořeny závislostí',
  subtitle: 'Jak vychovat děti pro současnost',
  text: `
Žijeme v revoluční době, která klade vysoké nároky jak na rodiče, tak na děti. O to více je třeba dbát na zajištění bezpečného vývoje, který začíná v době těhotenství matky, přechází obdobím dětství až k mladé dospělosti.
Přednáška nabízí fakta z výzkumů, které sledují základní chyby při výchově a nabízí informace jak výchovné handicapy snížit, případně jim zamezit. Protože se ocitáme v době, kdy kulturní vývoj, sycený blahobytem,  nerespektuje vývoj lidského jedince a to přináší četné potíže, včetně narůstajícího trendu dětských sebevražedných pokusů.

PhDr. Jan Svoboda je akreditovaným lektorem pro Českou i Slovenskou republiku, vystudoval jednooborovou psychologii a působil jako poradenský psycholog a psychoterapeut. V současné době je zaměstnán jako vysokoškolský učitel a odborný asistent na katedře školní a pedagogické psychologie Ostravské univerzity.
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/p06_koreny_zavislosti.js